import zxcvbn from 'zxcvbn';

class PasswordInputController {

    $onInit () {
        this.strength = {};
    }

    checkStrength () {
        this.strength = {};
        this.error = null;

        if(this.password) {
            this.strength = zxcvbn(this.password);
        }

        if(!this.password
            || !this.strength
            || !this.strength.score
            || this.strength.score < 3) {
            this.error = true;
        }
    }
}

PasswordInputController.$inject = [];

export default PasswordInputController;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/user/controllers/password.input.controller.js